import React from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import { getCurrencySymbol } from "../../../utils/GetCurrency"

const ComboPackCard = ({ combo, onEdit, onViewDetails, onDelete }) => {
  // console.log(localStorage.getItem("user"))

  let currencySymbol = getCurrencySymbol();
  // console.log("Currency Symbol:", currencySymbol);
  
  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "bg-success text-success-foreground";
      case "inactive":
        return "bg-secondary text-secondary-foreground";
      default:
        return "bg-muted text-muted-foreground";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "active":
        return "Active";
      case "inactive":
        return "Inactive";
      default:
        return "Unknown";
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-md micro-animation group">
      {/* ComboPack Header */}
      <div className="relative mb-4">
        {/* Status Badge */}
        <div
          className={`absolute top-2 right-2 px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
            combo.status
          )}`}
        >
          {getStatusText(combo.status)}
        </div>

        {/* Quick Actions */}
        <div className="absolute top-2 left-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
          <div className="flex space-x-1">
            <Button
              variant="secondary"
              size="icon"
              onClick={() => onEdit(combo)}
              className="w-8 h-8 shadow-sm"
            >
              <Icon name="Edit" size={14} />
            </Button>
            {/* Uncomment if you want delete */}
            {/* <Button
              variant="secondary"
              size="icon"
              onClick={() => onDelete(combo._id)}
              className="w-8 h-8 shadow-sm text-error hover:text-error"
            >
              <Icon name="Trash" size={14} />
            </Button> */}
          </div>
        </div>
      </div>

      {/* ComboPack Info */}
      <div className="space-y-3">
        {/* Name */}
        <div>
          <h3 className="font-semibold text-foreground text-lg mb-1 line-clamp-2">
            {combo.name}
          </h3>
          <p className="text-sm text-muted-foreground line-clamp-2">
            {combo.description || "No description available"}
          </p>
        </div>

        {/* Linked Products */}
        {combo?.linkedService?.length > 0 && (
          <div className="text-sm text-muted-foreground">
            <strong>Linked Products:</strong>{" "}
            <ul className="list-disc ml-5 mt-1">
              {combo.linkedService.map((item, index) => (
                <li key={index} className="text-foreground">
                  {item?.serviceId?.name || "Unnamed Product"}
                </li>
              ))}
            </ul>
          </div>
        )}

        {/* Visits, Price, Validity */}
        <div className="flex items-center justify-between">
          <div className="text-sm text-muted-foreground">
            <p>
              <strong>Total Visits:</strong> {combo.totalVisits}
            </p>
            <p>
              <strong>Validity:</strong> {combo.validityDays} days
            </p>
          </div>

          <div>
            <span className="text-2xl font-bold text-foreground">
              {currencySymbol}{combo.price?.toFixed(2)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComboPackCard;
